module.exports = __webpack_public_path__ + "img/icon-issue-ing.bc092a51.svg";